import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { Reveal, Eyebrow, SectionTitle } from "../Reveal";
import { track } from "../../lib/api";

const FAQS = [
  {
    q: "STOCKBOX 8 est-il déjà disponible à la vente ?",
    a: "Non. STOCKBOX 8 est actuellement un produit en développement. Ce site est un pré-lancement destiné à valider l'intérêt des professionnels français avant la production industrielle.",
  },
  {
    q: "Comment STOCKBOX 8 estime-t-il les quantités restantes ?",
    a: "Le concept prévoit une mesure du poids indépendante pour chacun des 8 compartiments. La quantité restante est ensuite estimée et affichée dans l'application. Il s'agit toujours d'une estimation, jamais d'un comptage exact.",
  },
  {
    q: "Quel est le prix de STOCKBOX 8 ?",
    a: "Le prix de lancement est en cours d'étude. Nous souhaitons définir le prix de STOCKBOX 8 avec les professionnels, grâce au questionnaire de prix disponible sur ce site. Aucun prix n'est définitif à ce stade.",
  },
  {
    q: "L'application mobile est-elle disponible ?",
    a: "Non. L'application est en conception. Les écrans présentés sur ce site sont des visuels d'illustration du fonctionnement prévu.",
  },
  {
    q: "Puis-je tester le prototype ?",
    a: "Oui. Nous recherchons des professionnels français pour tester le concept et participer à son amélioration. Indiquez votre intérêt via le questionnaire du site.",
  },
  {
    q: "Comment mes données sont-elles utilisées ?",
    a: "Vos réponses servent uniquement à l'étude de marché STOCKBOX 8. Aucune donnée marketing n'est utilisée sans votre consentement explicite. Vous pouvez demander la suppression de vos données à tout moment (voir notre politique de confidentialité).",
  },
];

export default function Faq() {
  return (
    <section id="faq" className="py-16 sm:py-24" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center">
          <Eyebrow>FAQ</Eyebrow>
          <SectionTitle>Questions fréquentes.</SectionTitle>
        </Reveal>
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="mt-10 space-y-3" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={f.q} value={`faq-${i}`}
                className="border border-[#2E333D] bg-[#141619] rounded-xl px-5 data-[state=open]:border-[#FFC700]/40 transition-colors">
                <AccordionTrigger
                  onClick={() => track("faq_open", { question: f.q })}
                  data-testid={`faq-question-${i}`}
                  className="text-left font-semibold text-[#F9FAFB] hover:text-[#FFC700] hover:no-underline py-5 text-sm sm:text-base"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-gray-400 text-sm leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
